import React, {Component} from 'react';
import {Field, FastField, ErrorMessage} from 'formik';
import {range} from 'lodash';
import get from 'lodash/get';
import classNames from 'classnames';
import {constants} from '@neosvoc/nv-platform-core-common';
import {MULTIPLE_NUMBER_1_PRESETS} from '../../../../constants';
import {FormattedMessage, injectIntl} from 'react-intl';
import messages from '../../../../../res/translations/messages';
import NumericSelect from '../NumericSelect';
import ChoiceOption from './ChoiceOption';
import Error from '../../../Error';

class MultipleNumberLogic extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {intl, id, field, item, form, label} = this.props;
        let options;
        if (!item.preset || item.preset === 0) {
            options = range(item.min, item.max + 1, item.step);
        } else {
            const preset = MULTIPLE_NUMBER_1_PRESETS.filter((i) => i.id === item.preset)[0];
            options = range(preset.min, preset.max + 1, preset.step);
        }

        return (
            <div className="row">
                <div className="col">
                    <label className="col-form-label" htmlFor={`${id}.condition.question`}><FormattedMessage {...messages.filters.row} /></label>
                    <Field id={`${id}.condition.question`} name={`${field.name}.condition.question`}
                        className={classNames('form-control custom-select',
                            {error: get(form.errors, `${field.name}.condition.question`) && get(form.touched, `${field.name}.condition.question`)})}
                        component="select">
                        <option value="">{intl.formatMessage(messages.filters.select)}</option>
                        {item.rows.map((item) => <ChoiceOption key={item.id} id={item.id} value={label(item)} />)}
                    </Field>
                    <ErrorMessage name={`${field.name}.condition.question`}>
                        {(message) => <Error reason={message.key} reasonParams={message.params} />}
                    </ErrorMessage>
                </div>
                <div className="col">
                    <label className="col-form-label" htmlFor={`${id}.condition.operator`}><FormattedMessage {...messages.filters.operator} /></label>
                    <FastField id={`${id}.condition.operator`} name={`${field.name}.condition.operator`}
                        className={classNames('form-control custom-select',
                            {error: get(form.errors, `${field.name}.condition.operator`) && get(form.touched, `${field.name}.condition.operator`)})}
                        component="select">
                        <option value="">{intl.formatMessage(messages.filters.select)}</option>
                        <option value={constants.EDITOR_OPERATORS.GT}>{intl.formatMessage(messages.filters.operators.greaterThan)}</option>
                        <option value={constants.EDITOR_OPERATORS.LT}>{intl.formatMessage(messages.filters.operators.lessThan)}</option>
                        <option value={constants.EDITOR_OPERATORS.EQ}>{intl.formatMessage(messages.filters.operators.equal)}</option>
                    </FastField>
                    <ErrorMessage name={`${field.name}.condition.operator`}>
                        {(message) => <Error reason={message.key} reasonParams={message.params} />}
                    </ErrorMessage>
                </div>
                <div className="col">
                    <label className="col-form-label" htmlFor={`${id}.condition.value`}><FormattedMessage {...messages.filters.value} /></label>
                    <NumericSelect id={`${id}.condition.value`} name={`${field.name}.condition.value`} options={options} />
                </div>
            </div>
        );
    }
}

export default injectIntl(MultipleNumberLogic);
